<template>
    <div class="hotel-location-label">
        <small v-if="offer.distance" class="font-weight-medium">
            <v-icon size="small" color="info">mdi-map-marker-distance</v-icon>
            {{ offer.distance }}
            {{ $t('km_from_center') }}
        </small>
        <small v-if="offer.district && offer.district !== 'other'" class="ms-6">
            <span class="font-weight-medium">{{ $t('area') }}:</span> {{ offer.district }}
        </small>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class HotelLocationLabel extends Vue {
        @Prop({required: true}) offer
    }

    export default HotelLocationLabel
</script>
